import React, { memo } from 'react';
import './Dots.css';

// Memoized Dots component that won't re-render with parent state changes
const Dots = memo(() => {
  const generateDots = () => {
    const dots = [];
    for (let i = 0; i < 150; i++) {
      const style = {
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 2}s`,
        animationDuration: `${2.5 + Math.random() * 1}s`,
      };
      dots.push(<div key={i} className='dot' style={style} />);
    }
    return dots;
  };

  // Generate dots only once when component mounts
  const dots = React.useMemo(() => generateDots(), []);

  return <div className='dots-container'>{dots}</div>;
});

export default Dots;
